export default "__VITE_ASSET__D_Fcyi4G__"